import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { ShieldCheck, User, Lock, Building2 } from "lucide-react";
import AxiosDB from "@/Config/AxiosDB";
import { sha256 } from "js-sha256";

export default function Login({ onLogin }) {

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    rnc: "",
    usuario: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    let encryptedPassword = sha256(formData.password).toString();


    try {
      const response = await AxiosDB.post(`/auth/login`, {
        ...formData,
        password: encryptedPassword

      });
      onLogin(response.data.access_token, response.data.user);
      toast.success("Bienvenido a Buzon Fiscal");
      navigate("/");
    } catch (error) {
      console.log(error)

      toast.error(
        error.response?.data?.detail || "Error al iniciar sesión"
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #0f4c81 0%, #1e5a9a 50%, #2563eb 100%)' }}>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-cyan-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      <Card className="w-full max-w-md shadow-2xl relative z-10" data-testid="login-card">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl shadow-lg">
              <ShieldCheck className="w-12 h-12 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Buzon Fiscal
          </CardTitle>
          <CardDescription className="text-base">
            Gestión de comprobantes fiscales electrónicos
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="rnc" className="text-sm font-medium">
                RNC
              </Label>
              <div className="relative">
                <Building2 className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
                <Input
                  id="rnc"
                  name="rnc"
                  type="text"
                  placeholder="Ingrese su RNC"
                  value={formData.rnc}
                  onChange={handleChange}
                  required
                  className="pl-10"
                  data-testid="rnc-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="usuario" className="text-sm font-medium">
                Usuario
              </Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
                <Input
                  id="usuario"
                  name="usuario"
                  type="text"
                  placeholder="Ingrese su usuario"
                  value={formData.usuario}
                  onChange={handleChange}
                  required
                  className="pl-10"
                  data-testid="usuario-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-medium">
                Contraseña
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
                <Input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Ingrese su contraseña"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="pl-10"
                  data-testid="password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              className="w-full h-11 text-base font-semibold bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
              disabled={loading}
              data-testid="login-button"
            >
              {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
            </Button>
          </form>


        </CardContent>
      </Card>
    </div>
  );
}